/**
 * Menu Image Configuration - Sjölin
 * 
 * Dette script viser billeder i mega-menuen baseret på blocks i header-sektionen.
 * Understøtter forskellige visningsstile, billedstørrelser og styling.
 */

(function() {

/* added by MB, WDN */
let debugMode = false; /* prevent inept code loggins from prev (inept or AI) developer... */
let megaMenuContentName = 'MegaMenu-Content';

if (document.body.classList.contains('theme-otr')) {
  megaMenuContentName = 'MegaMenu-OTR-Content';
}


  // Globale variabler
  let hasInitialized = false;
  let retryCount = 0;
  const MAX_RETRIES = 5;
  let renderedMenus = {}; // Hold styr på hvilke menuer der er renderet
  
  // Kør ved flere forskellige events for at sikre at vi fanger menuen uanset hvornår den indlæses
  document.addEventListener('DOMContentLoaded', initWithRetry);
  window.addEventListener('load', initWithRetry);
  
  // Vi kører også efter en kort forsinkelse for at sikre at alle elementer er indlæst
  setTimeout(initWithRetry, 500);
  
  function initWithRetry() {
    if (hasInitialized && retryCount > 0) return;
    
    try {
      if (debugMode) console.log('[MenuImages] Initializing... Attempt:', retryCount + 1);
      initMenuImages();
      retryCount++;
    } catch (err) {
      if (debugMode) console.error('[MenuImages] Initialization error:', err);
      
      // Prøv igen med en eksponentiel backoff, hvis vi ikke har nået max forsøg
      if (retryCount < MAX_RETRIES) {
        const delay = Math.pow(2, retryCount) * 500;
        if (debugMode)  console.log(`[MenuImages] Retrying in ${delay}ms`);
        setTimeout(initWithRetry, delay);
        retryCount++;
      }
    }
  }

  function initMenuImages() {
    if (debugMode)  console.log('[MenuImages] Starting initialization...');
    
    // Tilføj global styling for alle menu billeder
    addGlobalStyles();
    
    // DEBUG: Log alle mega-menuer i DOM
    const allMenus = document.querySelectorAll('details.mega-menu');
   if (debugMode)  console.log('[MenuImages] Found these mega-menus:', Array.from(allMenus).map(el => el.id));
    
    // Funktion til at hente block-data fra header elementes data-attributter
    function getMenuBlocks() {
      const header = document.querySelector('header.header');
      if (!header) {
       if (debugMode)  console.error('[MenuImages] Header element not found');
        return [];
      }

     if (debugMode)  console.log('[MenuImages] Header element found:', header);
      
      // DEBUG: Log alle data attributter på header
      const attributes = Array.from(header.attributes);
      const dataAttrs = attributes.filter(attr => attr.name.startsWith('data-'));
      if (debugMode)  console.log('[MenuImages] Header data attributes:', dataAttrs.map(attr => `${attr.name}=${attr.value}`));

      const blocksCount = parseInt(header.getAttribute('data-blocks-count') || '0', 10);
      if (debugMode) console.log('[MenuImages] Found blocks count:', blocksCount);
      
      if (!blocksCount) {
      if (debugMode)   console.log('[MenuImages] No blocks found');
        return [];
      }

      const blocks = [];
      for (let i = 1; i <= blocksCount; i++) {
        const menuTarget = header.getAttribute(`data-menu-target-${i}`);
        if (!menuTarget) {
       if (debugMode)    console.log(`[MenuImages] No target for block ${i}`);
          continue;
        }
        
        // Hent block indstillinger
        const block = {
          menuTarget: menuTarget,
          displayStyle: header.getAttribute(`data-menu-display-style-${i}`) || 'grid',
          imageWidth: parseInt(header.getAttribute(`data-menu-image-width-${i}`) || '200', 10),
          imageGap: parseInt(header.getAttribute(`data-menu-gap-${i}`) || '15', 10),
          borderRadius: parseInt(header.getAttribute(`data-menu-border-radius-${i}`) || '8', 10),
          showShadow: header.getAttribute(`data-menu-show-shadow-${i}`) !== 'false', // Standard er true
          hoverEffect: header.getAttribute(`data-menu-hover-effect-${i}`) || 'zoom', // ny
          overlayColor: header.getAttribute(`data-menu-overlay-color-${i}`) || 'rgba(0,0,0,0.7)', // ny
          zoomLevel: parseInt(header.getAttribute(`data-menu-zoom-level-${i}`) || '108', 10) / 100, // Konverter fra procent til decimal
          images: []
        };

        // Debug værdier
      if (debugMode)   console.log(`[MenuImages] Block ${i} settings:`, {
          target: block.menuTarget,
          style: block.displayStyle,
          width: block.imageWidth,
          gap: block.imageGap,
          hoverEffect: block.hoverEffect,
          overlayColor: block.overlayColor
        });

        // VIGTIG FIX: Shopify gemmer attributterne med dobbelt bindestreg (--) i stedet for (1-1)
        // Og nu sikrer vi at hvert menupunkt kun bruger billeder specifikt for det menupunkt
        for (let j = 1; j <= 5; j++) {
          // Specificér block index (i) korrekt i alle attribute navne
          let imageUrl = header.getAttribute(`data-menu-image-${i}-${j}`);
          let imageLink = header.getAttribute(`data-menu-link-${i}-${j}`);
          let imageAlt = header.getAttribute(`data-menu-alt-${i}-${j}`);
          let focalX = header.getAttribute(`data-menu-focal-x-${i}-${j}`) || '50';
          let focalY = header.getAttribute(`data-menu-focal-y-${i}-${j}`) || '50';
          
          // Tjek også double-dash format, men med korrekt block index
          if (!imageUrl) {
            // Dette format er også indekseret med block nummer
            const doubleAttributeName = `data-menu-image-${i}--${j}`;
            imageUrl = header.getAttribute(doubleAttributeName);
         if (debugMode)    console.log(`[MenuImages] Checking double-dash attribute: ${doubleAttributeName} = ${imageUrl ? 'Found' : 'Not found'}`);
            
            if (!imageUrl) {
              // Legacy format uden block index
              imageUrl = header.getAttribute(`data-menu-image--${j}`);
              imageLink = header.getAttribute(`data-menu-link--${j}`);
              imageAlt = header.getAttribute(`data-menu-alt--${j}`);
         if (debugMode)      console.log(`[MenuImages] Checking legacy format for image ${j}: ${imageUrl ? 'Found' : 'Not found'}`);
            }
          }
          
          // Hvis vi fandt et billede, tilføj det til blokken
          if (imageUrl) {
            // Konverter focal point værdier fra streng til tal
            const focalXNum = parseInt(focalX, 10);
            const focalYNum = parseInt(focalY, 10);
            
            block.images.push({
              url: imageUrl,
              link: imageLink || '',
              alt: imageAlt || `Menu billede ${j}`,
              focalX: focalXNum,
              focalY: focalYNum
            });
            
            // Mere beskrivende logning af focal point
            let focalXDesc = 'centreret';
            if (focalXNum <= 0) focalXDesc = 'helt til venstre';
            else if (focalXNum <= 25) focalXDesc = 'lidt til venstre';
            else if (focalXNum >= 100) focalXDesc = 'helt til højre';
            else if (focalXNum >= 75) focalXDesc = 'lidt til højre';
            
            let focalYDesc = 'centreret';
            if (focalYNum <= 0) focalYDesc = 'helt i top';
            else if (focalYNum <= 25) focalYDesc = 'lidt i top';
            else if (focalYNum >= 100) focalYDesc = 'helt i bund';
            else if (focalYNum >= 75) focalYDesc = 'lidt mod bund';
            
           if (debugMode)  console.log(`[MenuImages] Added image ${j} to menu block ${i}, URL: ${imageUrl}, Focal point: ${focalXDesc}, ${focalYDesc} (${focalXNum}%, ${focalYNum}%)`);
          }
        }

        if (block.images.length > 0) {
          blocks.push(block);
       if (debugMode)    console.log(`[MenuImages] Added block for menu ${menuTarget} with ${block.images.length} images`);
        } else {
         if (debugMode)  console.log(`[MenuImages] No images found for block ${i}`);
        }
      }

      return blocks;
    }
    
    // Tilføj global CSS styling
    function addGlobalStyles() {
      const styleId = 'menu-images-global-styles';
      
      // Undgå at tilføje styles flere gange
      if (document.getElementById(styleId)) return;
      
      const styleElement = document.createElement('style');
      styleElement.id = styleId;
      styleElement.textContent = `
        .custom-image-menu {
          padding: 25px 0 !important;
          margin-top: 20px !important;
          border-top: 1px solid rgba(0,0,0,0.1);
          width: 100%;
          box-sizing: border-box;
          opacity: 1;
          transition: opacity 0.2s ease;
        }
        
        .custom-image-menu.loading {
          opacity: 0;
        }
        
        .menu-image-wrapper {
          position: relative;
          overflow: hidden;
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        
        .menu-image-wrapper:hover {
          transform: translateY(-5px);
          box-shadow: 0 12px 20px rgba(0,0,0,0.15);
          z-index: 1;
        }
        
        .menu-image {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }
        
        /* Hover effekter */
        .menu-image-wrapper.hover-zoom:hover .menu-image {
          transform: scale(var(--zoom-level, 1.08));
        }
        
        .menu-image-wrapper.hover-zoom-rotate:hover .menu-image {
          transform: scale(var(--zoom-level, 1.08)) rotate(2deg);
        }
        
        .menu-image-wrapper.hover-brighten:hover .menu-image {
          filter: brightness(1.1);
        }
        
        .menu-image-wrapper.hover-contrast:hover .menu-image {
          filter: contrast(1.1);
        }
        
        .menu-image-wrapper.hover-sepia:hover .menu-image {
          filter: sepia(0.3);
        }
        
        .menu-image-title {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: transparent;
          color: white;
          padding: 18px 15px 12px;
          margin: 0;
          font-size: 14px;
          font-weight: 600;
          opacity: 1;
          text-align: left;
          text-shadow: 0 1px 4px rgba(0,0,0,1), 0 0 8px rgba(0,0,0,0.7);
          line-height: 1.3;
        }
        
        /* Fjern hover effekt for titel, da den nu altid er synlig */
        .menu-image-wrapper:hover .menu-image-title {
          transform: none;
        }
        
        /* Masonry specifik styling */
        .custom-image-menu.masonry-layout {
          column-gap: 15px;
          column-count: 4;
        }
        
        .custom-image-menu.masonry-layout .menu-image-wrapper {
          break-inside: avoid;
          margin-bottom: 15px;
        }
        
        /* Carousel specifik styling */
        .custom-image-menu.carousel-layout {
          display: flex;
          overflow-x: auto;
          overflow-y: hidden;
          scroll-snap-type: x mandatory;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: none; /* Firefox */
          position: relative;
          padding-bottom: 25px !important;
        }
        
        .custom-image-menu.carousel-layout::-webkit-scrollbar {
          display: none;
        }
        
        .custom-image-menu.carousel-layout .menu-image-wrapper {
          scroll-snap-align: start;
          flex-shrink: 0;
          margin-right: 15px;
        }
        
        .custom-image-menu.carousel-layout::after {
          content: '';
          display: block;
          flex-shrink: 0;
          width: 20px;
          height: 1px;
        }
        
        /* Grid specifik styling */
        .custom-image-menu.grid-layout {
          display: grid;
          gap: 15px;
        }
        
        /* Nav knapper for carousel */
        .carousel-nav {
          display: flex;
          justify-content: center;
          gap: 10px;
          margin-top: 10px;
        }
        
        .carousel-nav button {
          background: #f5f5f5;
          border: none;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.3s ease;
          box-shadow: 0 2px 5px rgba(0,0,0,0.1);
        }
        
        .carousel-nav button:hover {
          background: #e5e5e5;
        }
        
        .carousel-nav button svg {
          width: 16px;
          height: 16px;
        }
      `;
      
      document.head.appendChild(styleElement);
      if (debugMode)  console.log('[MenuImages] Global styles added');
    }

    // Find eller opret custom-image-menu containeren
    function getOrCreateImageContainer(menuId) {
      // Find mega-menu elementet
 if (debugMode)      console.log(`[MenuImages] Looking for menu element with ID: ${menuId}`);
      
      const menuElement = document.getElementById(menuId);
      if (!menuElement) {
    if (debugMode)     console.error(`[MenuImages] Menu element not found: ${menuId}`);
        
      
        return null;
      }
      
 if (debugMode)      console.log(`[MenuImages] Found menu element:`, menuElement);

      // Undersøg om der allerede findes en container eller om vi skal oprette en
      let container = menuElement.querySelector('.custom-image-menu');
      
      if (!container) {
   if (debugMode)      console.log(`[MenuImages] No existing container found in ${menuId}, creating new container`);
        
        // Tjek om der er en "mega-menu__list" i menuen, vi skal indsætte efter
        const megaMenuList = menuElement.querySelector('.mega-menu__list');
        if (megaMenuList) {
 if (debugMode)          console.log(`[MenuImages] Found mega-menu__list, will insert after it`);
        } else {
 if (debugMode)          console.log(`[MenuImages] No mega-menu__list found, will insert directly in menu element`);
        }
        
        // Opret containeren
        container = document.createElement('div');
        container.className = 'custom-image-menu loading';
        container.setAttribute('data-menu-id', menuId); // Tilføj menu ID for at undgå forvirring
        
        // Indsæt containeren i DOM
        if (megaMenuList) {
          // Indsæt efter mega-menu__list hvis den findes
          megaMenuList.insertAdjacentElement('afterend', container);
        } else {
          // Ellers indsæt direkte i menuen
          menuElement.appendChild(container);
        }
        
 if (debugMode)        console.log(`[MenuImages] Container created and added to DOM`);
      } else {
  if (debugMode)       console.log(`[MenuImages] Found existing container in ${menuId}`);
      }
      
      return container;
    }

    // Render billeder baseret på block-data
    function renderMenuImages(forceRender = false) {
      const blocks = getMenuBlocks();
      if (!blocks.length) {
      if (debugMode)   console.log('[MenuImages] No blocks to render');
        return;
      }

      blocks.forEach(block => {
        // Skip hvis denne menu allerede er renderet og vi ikke tvinger en genrender
        if (renderedMenus[block.menuTarget] && !forceRender) {
       if (debugMode)    console.log(`[MenuImages] Menu ${block.menuTarget} already rendered`);
          return;
        }
        
        // Find menuen baseret på ID
        const menuContainer = getOrCreateImageContainer(block.menuTarget);
        if (!menuContainer) {
       if (debugMode)   console.log(`[MenuImages] Could not get container for ${block.menuTarget}, skipping`);
          return;
        }

        // Reset container og stil
      if (debugMode)   console.log(`[MenuImages] Rendering images for ${block.menuTarget}`);
        menuContainer.innerHTML = '';
        menuContainer.classList.add('loading');
        
        // Preload alle billeder før vi viser containeren
        const imagesToLoad = block.images.length;
        let imagesLoaded = 0;
        
        // Funktion der tjekker om alle billeder er indlæst
        function checkAllImagesLoaded() {
          imagesLoaded++;
          if (imagesLoaded >= imagesToLoad) {
            // Alle billeder indlæst - vis containeren
            setTimeout(() => {
              menuContainer.classList.remove('loading');
            }, 100);
          }
        }
        
        // Tilføj klasse baseret på displayStyle
        menuContainer.classList.remove('grid-layout', 'carousel-layout', 'masonry-layout');
        menuContainer.classList.add(`${block.displayStyle}-layout`);
        
        // Stil afhængigt af displayStyle
        if (block.displayStyle === 'grid') {
          menuContainer.style.gridTemplateColumns = `repeat(auto-fill, minmax(${block.imageWidth}px, 1fr))`;
          menuContainer.style.gap = `${block.imageGap}px`;
        } else if (block.displayStyle === 'carousel') {
          menuContainer.style.gap = `${block.imageGap}px`;
          
          // Tilføj navigation knapper for carousel
          const carouselNav = document.createElement('div');
          carouselNav.className = 'carousel-nav';
          
          const prevButton = document.createElement('button');
          prevButton.innerHTML = '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/></svg>';
          prevButton.setAttribute('aria-label', 'Forrige');
          prevButton.addEventListener('click', () => {
            menuContainer.scrollBy({ left: -block.imageWidth - block.imageGap, behavior: 'smooth' });
          });
          
          const nextButton = document.createElement('button');
          nextButton.innerHTML = '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"/></svg>';
          nextButton.setAttribute('aria-label', 'Næste');
          nextButton.addEventListener('click', () => {
            menuContainer.scrollBy({ left: block.imageWidth + block.imageGap, behavior: 'smooth' });
          });
          
          carouselNav.appendChild(prevButton);
          carouselNav.appendChild(nextButton);
          
          // Indsæt navigationen efter carousel containeren
          menuContainer.insertAdjacentElement('afterend', carouselNav);
          
        } else if (block.displayStyle === 'masonry') {
          menuContainer.style.columnCount = Math.max(3, Math.floor(menuContainer.offsetWidth / (block.imageWidth + block.imageGap)));
          menuContainer.style.columnGap = `${block.imageGap}px`;
        }
        
        // For hver billede, opret wrapper med styling baseret på indstillinger
        block.images.forEach((image, index) => {
          // Opret wrapper
          const wrapper = document.createElement('div');
          wrapper.className = `menu-image-wrapper hover-${block.hoverEffect}`;
          wrapper.setAttribute('data-menu-id', block.menuTarget); // Tilføj menu ID for at undgå forvirring
          wrapper.style.setProperty('--zoom-level', block.zoomLevel);
          
          if (block.displayStyle === 'carousel') {
            wrapper.style.cssText = `
              flex: 0 0 ${block.imageWidth}px;
              width: ${block.imageWidth}px;
              height: ${Math.floor(block.imageWidth * 1.2)}px;
              border-radius: ${block.borderRadius}px;
              ${block.showShadow ? 'box-shadow: 0 8px 15px rgba(0,0,0,0.1);' : ''}
            `;
          } else if (block.displayStyle === 'masonry') {
            wrapper.style.cssText = `
              width: 100%;
              border-radius: ${block.borderRadius}px;
              ${block.showShadow ? 'box-shadow: 0 8px 15px rgba(0,0,0,0.1);' : ''}
            `;
          } else {
            wrapper.style.cssText = `
              border-radius: ${block.borderRadius}px;
              ${block.showShadow ? 'box-shadow: 0 8px 15px rgba(0,0,0,0.1);' : ''}
              aspect-ratio: ${index % 3 === 0 ? '1/1.2' : '1/1'};
            `;
          }

          // Opret link hvis angivet
          const linkElement = image.link ? document.createElement('a') : null;
          if (linkElement) {
            linkElement.href = image.link;
            linkElement.style.cssText = 'display: block; text-decoration: none; height: 100%;';
          }

          // Opret billedelement
          const img = new Image();
          img.alt = image.alt;
          img.className = 'menu-image';
          img.setAttribute('data-menu-id', block.menuTarget); // Tilføj menu ID for at undgå forvirring
          
          // Anvend focal point styling
          if (image.focalX !== 50 || image.focalY !== 50) {
            img.style.objectPosition = `${image.focalX}% ${image.focalY}%`;
       if (debugMode)      console.log(`[MenuImages] Applied focal point to image: ${image.focalX}%, ${image.focalY}%`);
          }
          
          // Opret titel element
          const titleEl = document.createElement('p');
          titleEl.className = 'menu-image-title';
          titleEl.textContent = image.alt;
          
          // Fjernet gradient og overlay baggrund - nu transparent
          
          // Indlæsnings-event før vi sætter src for at undgå problemer
          img.onload = function() {
     if (debugMode)        console.log(`[MenuImages] Image ${index + 1} in menu ${block.menuTarget} loaded successfully`);
            checkAllImagesLoaded();
          };
          
          img.onerror = function() {
     if (debugMode)       console.error(`[MenuImages] Error loading image ${index + 1} for menu ${block.menuTarget}:`, image.url);
            checkAllImagesLoaded(); // Tæl også fejlede billeder med, så vi ikke hænger fast
          };
          
          // VIGTIGT: Sørg for at URL er korrekt
          if (image.url.includes('?') && !image.url.includes('&width=')) {
            // Tilføj bredde parameter for at sikre billede vises korrekt
            img.src = `${image.url}&width=800`; // Større billeder for bedre kvalitet
       if (debugMode)      console.log(`[MenuImages] Adjusted image URL to: ${img.src}`);
          } else {
            img.src = image.url;
          }

          // Saml elementerne
          if (linkElement) {
            linkElement.appendChild(img);
            linkElement.appendChild(titleEl);
            wrapper.appendChild(linkElement);
          } else {
            wrapper.appendChild(img);
            wrapper.appendChild(titleEl);
          }

          // Tilføj til container
          menuContainer.appendChild(wrapper);
   if (debugMode)        console.log(`[MenuImages] Added image ${index + 1} to menu ${block.menuTarget}`);
        });
        
        // Double-check at indhold blev tilføjet
   if (debugMode)      console.log(`[MenuImages] Container now has ${menuContainer.children.length} child elements for menu ${block.menuTarget}`);
        
        // Marker menuen som renderet
        renderedMenus[block.menuTarget] = true;
      });
      
      // Marker som initialiseret
      hasInitialized = true;
    }

    // Manuelle check for at se om menuer allerede er åbne
    function checkOpenMenus() {
      const allMenus = document.querySelectorAll('details.mega-menu');
   if (debugMode)    console.log(`[MenuImages] Checking ${allMenus.length} menus for open state`);
      
      allMenus.forEach(menu => {
        if (menu.hasAttribute('open')) {
    if (debugMode)       console.log(`[MenuImages] Found open menu: ${menu.id}`);
          const menuContent = document.getElementById(menu.id.replace('Details-HeaderMenu', megaMenuContentName));
          if (menuContent) {
      if (debugMode)       console.log(`[MenuImages] Found corresponding content: ${menuContent.id}`);
            // Render menuen hvis den er åben
            renderMenuImages(false);
          }
        }
      });
    }

    // Lyt direkte på klik på header menu-items for at fange menu åbninger
    function setupMenuClickListeners() {
      const menuItems = document.querySelectorAll('.header__menu-item');
if (debugMode)       console.log(`[MenuImages] Found ${menuItems.length} menu items to observe`);
      
      menuItems.forEach(item => {
        item.addEventListener('click', () => {
          // På klik, vent et øjeblik og prøv at render
    if (debugMode)       console.log('[MenuImages] Menu item clicked');
          setTimeout(() => {
            renderMenuImages(false);
          }, 50);
        });
      });
    }

    // Observer for at detektere når mega-menuer åbnes
    function setupMegaMenuObserver() {
      try {
        const observer = new MutationObserver(mutations => {
          for (const mutation of mutations) {
            if (mutation.type === 'attributes' && 
                mutation.attributeName === 'open' && 
                mutation.target.hasAttribute('open')) {
              
              const menuId = mutation.target.id;
         if (debugMode)      console.log('[MenuImages] Menu opened:', menuId);
              
              // Find det tilsvarende indhold (konverter fra Details-HeaderMenu-X til MegaMenu-Content-X)
              if (menuId.startsWith('Details-HeaderMenu-')) {
                const contentId = menuId.replace('Details-HeaderMenu', megaMenuContentName);
     if (debugMode)            console.log(`[MenuImages] Looking for content with ID: ${contentId}`);
                
                // Render med det samme - uden at tvinge re-render
                renderMenuImages(false);
              }
            }
          }
        });

        // Observer alle mega menu details elementer
        const megaMenus = document.querySelectorAll('details.mega-menu');
        megaMenus.forEach(menu => {
          observer.observe(menu, { attributes: true });
    if (debugMode)       console.log('[MenuImages] Observing menu:', menu.id);
          
          // Hvis menuen allerede er åben, render med det samme
          if (menu.hasAttribute('open')) {
            console.log('[MenuImages] Menu already open:', menu.id);
            renderMenuImages(false);
          }
        });
        
 if (debugMode)        console.log(`[MenuImages] Observing ${megaMenus.length} mega menus`);
      } catch (err) {
 if (debugMode)        console.error('[MenuImages] Error setting up observer:', err);
      }
    }

    // Initialiser alle
    setupMegaMenuObserver();
    setupMenuClickListeners();
    checkOpenMenus();
    
    // Kør første render
    renderMenuImages();
  }
})(); 